import { render } from "./Textarea.vue?vue&type=template&id=52ed9744&scoped=true&bindings={}"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"

import "./Textarea.vue?vue&type=style&index=0&id=52ed9744&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52ed9744"

export default script